import React, { useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useProjectUIContext } from "./ProjectUIContext";
import ProjectTable from "./project-table/ProjectTable";
import { ProjectFilter } from "./project-filter/ProjectFilter";
import { BlockOrg, RoleChecker } from "../../../RoleChecker";

export const ProjectCard = () => {
  const projectUIContext = useProjectUIContext();
  const projectUIProps = useMemo(() => {
    return {
      newProjectButtonClick: projectUIContext.newProjectButtonClick,
    };
  }, [projectUIContext]);

  return (
    <Card>
      <CardHeader title="Daftar Project">
        <CardHeaderToolbar>
          {BlockOrg() && RoleChecker("Create", "project") && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={projectUIProps.newProjectButtonClick}
            >
              Project Baru
            </button>
          )}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <ProjectFilter />
        <ProjectTable />
      </CardBody>
    </Card>
  );
};
